export {default as dispatch} from "./dispatch";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-dispatch/src/index.js
// module id = 141
// module chunks = 0